// extracted by mini-css-extract-plugin
export var copy = "paidSearch-module--copy--6508b";
export var copyWrapper = "paidSearch-module--copy-wrapper--f4d96";
export var ctaCenter = "paidSearch-module--cta-center--356bb";
export var ctaFooter = "paidSearch-module--cta-footer--661d1";
export var figure = "paidSearch-module--figure--a9c57";
export var form = "paidSearch-module--form--73490";
export var formHeader = "paidSearch-module--form-header--a61d3";
export var formWrapper = "paidSearch-module--form-wrapper--3097e";
export var heading = "paidSearch-module--heading--b26f8";
export var heroMedia = "paidSearch-module--hero-media--182b1";
export var sectionHeader = "paidSearch-module--section-header--07d98";
export var videoWrap = "paidSearch-module--video-wrap--c223e";